export function formatDeparture(departure, t) {
  if (!departure) return "";
  const depStr = String(departure).trim();
  if (t) {
    const direct = t(depStr);
    if (direct && direct !== depStr) {
      return direct;
    }
    const upper = t(depStr.toUpperCase());
    if (upper && upper !== depStr.toUpperCase()) {
      return upper;
    }
  }
  return depStr
    .toLowerCase()
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
